import {Fragment} from "react";
import PersonForm from "../../../../component/PersonForm/PersonForm";
import TextInput from "../../../../component/TextInput/TextInput";

const CustomerForm = ({customer , onChange}) => {

    const changeCustomer = (key, value) => {
        const newDriver = {...customer, [key]: value}
        onChange(newDriver);
    }

    return (
        <Fragment>
            <PersonForm person={customer.person} onChange={(value) => {
                changeCustomer("person", value);
            }}/>
            <div className="row">
                <div className="col-md-6">
                    <TextInput label={"آیدی مشتری معرف"} type={"number"} value={customer.representativeCustomerId}
                               onChange={(value) => {
                                   changeCustomer("representativeCustomerId", value);
                               }}/>
                </div>
            </div>


        </Fragment>
    );
}

export default CustomerForm;